import { render, staticRenderFns } from "./Fixtures.vue?vue&type=template&id=a4235522&scoped=true&"
import script from "./Fixtures.vue?vue&type=script&lang=js&"
export * from "./Fixtures.vue?vue&type=script&lang=js&"
import style0 from "./Fixtures.vue?vue&type=style&index=0&id=a4235522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4235522",
  null
  
)

export default component.exports